//-----------------------------------------------------------------------------
//----- Copyright deersoft 2015 - 2019 www.deersoft.de
//-----------------------------------------------------------------------------
export const kVoucherStorageKey = "production-assist-training-voucher-token";
export const kVoucherRedemptionPath = "/redeem-training-voucher";
const kCapturedTokens = new WeakMap<Window, string>();

export function getVoucherRedemptionErrorKey(error?: { message?: string; status?: number }) {
  switch (error?.message) {
    case "RECIPIENT_MISMATCH": return "RecipientMismatch";
    case "ACCOUNT_NOT_ELIGIBLE":
    case "ACCOUNT_ALREADY_REDEEMED": return "RecipientNotEligible";
    case "ACCOUNT_SUBSCRIPTION_BUSY": return "SubscriptionBusy";
    case "INVALID_OR_EXPIRED_VOUCHER":
    case "VOUCHER_ALREADY_REDEEMED": return "VoucherInvalid";
    default: return "RequestFailed";
  }
}

export function captureVoucherToken(browserWindow: Window = typeof window === "undefined" ? undefined : window) {
  if (!browserWindow?.location) return null;
  const { location, history } = browserWindow;
  const fragmentToken = new URLSearchParams(location.hash.replace(/^#/, "")).get("token");
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
  if (fragmentToken && normalizedPath === kVoucherRedemptionPath) {
    kCapturedTokens.set(browserWindow, fragmentToken);
    history.replaceState(history.state, "", `${location.pathname}${location.search}`);
  }
  try {
    const token = kCapturedTokens.get(browserWindow);
    if (token) browserWindow.sessionStorage.setItem(kVoucherStorageKey, token);
    return browserWindow.sessionStorage.getItem(kVoucherStorageKey) || null;
  } catch (_error) {
    return kCapturedTokens.get(browserWindow) || null;
  }
}

export function clearVoucherToken(browserWindow: Window = window) {
  kCapturedTokens.delete(browserWindow);
  try {
    browserWindow.sessionStorage.removeItem(kVoucherStorageKey);
  } catch (_error) {
    return;
  }
}

export function getVoucherDateFilter(value: string, endOfDay = false) {
  if (!value) return undefined;
  const date = new Date(`${value}T00:00:00`);
  if (endOfDay) date.setHours(23, 59, 59, 999);
  return date.toISOString();
}
